import gql from 'graphql-tag';

import { executeGqlQuery } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';

import { INTEGRATION_ASSET_STATUS } from './schema';

const QUERY = gql`
  query IntegrationAssetStatus(
    $customerId: ID!
    $dataSource: PerformanceCenterDataSource
    $accountId: ID
    $statuses: [IntegrationAssetStatus!]
  ) {
    integrationAssets(
      customerId: $customerId
      dataSource: $dataSource
      accountId: $accountId
      statuses: $statuses
    ) {
      ...IntegrationAssetStatus
    }
  }
  ${INTEGRATION_ASSET_STATUS}
`;

export const queryIntegrationAssetStatus = (
  { customerId, dataSource, accountId, statuses },
  options = null
) => {
  return executeGqlQuery({
    query: QUERY,
    variables: {
      customerId,
      dataSource,
      accountId,
      statuses,
    },
    options: {
      abortSignal: options?.abortSignal,
    },
  }).then(({ data }) => getSingleProp(data));
};
